<template src="./Index.html">
</template>


<script>
import AddView from './actions/Add.vue';
import EditView from "./actions/Edit.vue";
import DetailsView from "./actions/Details.vue";

export default {
  components: {
    AddView,
    EditView,
    DetailsView,
  },
  created() {
    this.getAll();
    this.$store.dispatch("lookups/getLookups");

  },
  computed: {
    pageCount() {
      return Math.ceil(
        this.$store.state.medicines.totalItems / this.filters.pageSize
      );
    },
    medicines() {
      return this.$store.state.medicines.medicines;
    },
    medicineTypes() {
      return [
        { value: 0, label: "الكل" },
        ...this.$store.getters["lookups/getLookupByType"](
          this.$lookupTypes.MedicineTypes
        )];
    },
   

  },

  data() {
    return {
      permissions: this.$inventoryManagementPermissions.MedicinesPermissions,

      view: 0,

      dialog: false,
      dialogType: null,
      dialogMessage: "",

      filters: {
        page: 1,
        pageSize: 10,
        medicineName: null,
        medicineTypeId: 0,
      },
      headers: [
        { text: 'الاسم ', value: 'medicineName' },
        { text: 'النوع ', value: 'medicineType' },
        { text: 'الجرعة ', value: 'dosage' },
        { text: 'الوحدة ', value: 'unit' },
        { text: "مسجل بواسطة", value: "createdBy", sortable: false },
        { text: "تاريخ التسجيل", value: "createdOn", sortable: false },
        { text: 'الاجراءات', value: 'actions', sortable: false },
      ],

      itemId: 0,
    };
  },
  methods: {
    getAll(page) {
      this.filters.page = page || 1;
      this.$store.dispatch("medicines/getAll", this.filters);

    },

    addItem() {
      this.view = 1;
    },
    viewItem(item) {
      this.itemId = item.id;
      this.view = 3;
      // Implement view logic
    },
    editItem(item) {
      this.itemId = item.id;
      this.view = 2;
      // Implement edit logic
    },
    showDialog(item, type) {
      switch (type) {
        case "delete":
          this.dialogMessage = "هل انت متأكد من رغبتك حذف البيانات";
          break;
        case "lock":
          this.dialogMessage = "هل انت متأكد من رغبتك تجميد البيانات";
          break;
        case "unlock":
          this.dialogMessage = "هل انت متأكد من رغبتك تفعيل البيانات";
          break;
      }
      this.dialogType = type;
      this.itemId = item.id;
      this.dialog = true;
    },

    confirmDialog() {
      this.$store.dispatch(`medicines/${this.dialogType}`, this.itemId);
      this.cancelDialog();
    },

    cancelDialog() {
      this.dialog = false;
      this.itemId = 0;
      this.dialogMessage = "";
      this.dialogType = null;
    },
    back() {
      this.view = 0;
    }
  },
};
</script>

<style scoped></style>